import { Badge, Box, ButtonBase } from "@mui/material"

export const PrimaryButton = ({ sx, children, badgeContent, badgeSx, ...props }) => {
    const { className, ...restProps } = props;
    return (
        <ButtonBase  {...restProps}
            sx={{
                ...sx, border: '1.5px solid #000',
            }}

        >
            {
                children
            }
        </ButtonBase>
    )
}